// extracted by mini-css-extract-plugin
export var actions = "_mn-5";
export var assistantBubble = "_mn-3";
export var assistantRow = "_mn-6";
export var bubble = "_mn-0";
export var humanAvatar = "_mn-4";
export var inlineToolCard = "_mn-1";
export var userBubble = "_mn-2";